export default __webpack_public_path__ + "static/media/logoLoc.fa68ee5f.png";